<template>
  <div class="full-page eemo-gray" v-if="showHistory == true && orderHistory != null && orderHistory.length > 0">
    <!--      <div class="floating-container ">-->
    <div id="history-container" class="container h-100" style="overflow-y: scroll; padding-top:10px; padding-bottom: 10px;">
      <div class="row">
        <div class="col-12 big-name">
          <span style="float:left" v-on:click="backPressed"><i class="fas fa-arrow-left"></i></span>Your Orders
        </div>
      </div>
      <div class="row" v-for="(h, index) in orderHistory" :id="'history-item-' + h.id">
        <div class="col-12">
          <div class="order-item-container" :class="'order-status-' + h.state">
            <div class="order-item-merchant">#{{h.id}} {{h.merchantName}}</div>
            <div class="order-item-merchant-info" v-if="h.merchantInfo != undefined && h.merchantInfo != null">
              <div v-if="h.merchantInfo.merchantAddress != undefined && h.merchantInfo.merchantAddress != null" v-html="h.merchantInfo.merchantAddress.replace(/\n/g, '<br>')"></div>
              <div v-if="h.merchantInfo.contact != undefined && h.merchantInfo.contact != null"><a :href="'tel:'+ h.merchantInfo.contact">{{h.merchantInfo.contact}}</a></div>
            </div>
            <hr>
            <div class="order-item-title">Order Time: {{new Date(h.createdTimestamp).toLocaleString()}}</div>
            <p v-if="h.state < 5 && h.pickupTime != null && h.pickupTime.length > 0"><strong>Pickup Time:</strong> {{h.pickupTime}}</p>
            <div class="order-item-status"><strong>Status</strong><br>{{getOrderStateString(h.state, h.recordType, h.merchantName)}}</div>
            <qrcode-vue v-if="h.salesReference != null && h.salesReference.length == 12 && h.state > 4 && h.state < 6":value="h.salesReference" :size="150" level="H"></qrcode-vue>
            <div class="order-item-message-to-confirm" v-if="h.state == 1">

              <p>{{h.message}}</p>
              <button class="btn btn-primary" v-on:click="acceptChange(h)">Accept</button>
              <button class="btn btn-danger" v-on:click="cancelChange(h)">Cancel</button>
            </div>

            <div class="order-item-description">
              <div class="order-section-title">Order details</div>
              <table class="table">
                <tr v-for="order in h.list">
                  <td>{{getHistoryOrderItemName(order)}} x {{order.amount}}<span v-if="order.memo != null && order.memo.length > 0"><br>Memo:{{order.memo}}</span></td>
                  <td class="text-right">£{{(order.totalPrice/100).toFixed(2)}}</td>
                </tr>
                <tr v-if="h.deliveryCharge > 0">
                  <td>Delivery Charge</td>
                  <td class="text-right">£{{(h.deliveryCharge/100).toFixed(2)}}</td>
                </tr>
              </table>

            </div>
            <div v-if="h.memo != null && h.memo.length > 0">Memo: {{h.memo}}</div>


            <div v-if="h.postCode != null && h.postCode.length > 0">{{h.postCode}}</div>
            <div v-if="h.address != null && h.address.length > 0" v-html="h.address.replace(/\n/g, '<br>')"></div>
            <div class="order-item-price">£{{((h.totalDue/100).toFixed(2))}}</div>
            <!--                <div v-if="points != false && h.points > 0">-->
            <!--                  {{h.points}} {{points.unitTitle}}-->
            <!--                </div>-->
          </div>
        </div>
        <!--          </div>-->
      </div>
    </div>
  </div>
</template>

<script>
    import {getMyOrder} from "../api/borium";
    import EventBus from "../api/event-bus";
    import QrcodeVue from "qrcode.vue";

    export default {
        name: "History",
        data() {
          return {
            orderHistory:[],
            showHistory: false,

            mqtt:null,
            mqttDisconnect: false,
            topics:[],
          }
        },
      components: {
        QrcodeVue,
      },
      created() {
        EventBus.$off('backPressed', this.backPressed);
        EventBus.$on('backPressed', this.backPressed);
        EventBus.$emit("modeChanged", 1);
        $("#nav-top").removeClass("transparent-background");
        this.getHistory();
      },
      mounted() {
        EventBus.$emit("setTitle", "Orders");
      },
      beforeDestroy() {
        EventBus.$off('backPressed', this.backPressed);
        this.$data.mqttDisconnect = true;
      },
      beforeRouteLeave(to, from, next) {
        // console.log("beforeRouteLeave");
        if(this.backPressed() == true) {
          // console.log("back key handled");
          next(false);
        } else {
          // console.log("move to home");
          next();
        }
      },
      methods: {
        backPressed: function(fromNav = false) {
          if(fromNav == true) {
            // Router.push('/home');
            history.go(-1)
          }
          return false;
        },
        getHistory: function() {
          // console.log("getHistory");
          if(localStorage.getItem("tel") != null && localStorage.getItem("tel").length == 11) {
            let self = this;
            this.$data.showHistory = true;
            getMyOrder(localStorage.getItem("tel"), 0)
              .then(function(data) {
                console.log("my order list ");
                console.log(data);
                if(data.success == true) {
                  let needToSubscribe = false;
                  for(let i = 0 ; i < data.item.length ; i++) {
                    if(data.item[i].title != null && data.item[i].title.length > 0) {
                      data.item[i].merchantInfo = JSON.parse(data.item[i].title);
                    }
                    if(data.item[i].state > 0 && data.item[i].state < 6) {
                      needToSubscribe = true;
                    }
                  }
                  self.$data.orderHistory = data.item;
                  if(needToSubscribe) {
                    self.connect();
                  }
                }
              })
              .catch(function(err) {
                console.log(err);
                if(err.response != undefined) {
                  //console.log(err.response);
                }
              })
            // this.subscribe(localStorage.getItem("tel"));
          } else {
            // console.log("getHistory no tel");
          }


        },
        getHistoryOrderItemName: function(item) {
          let title = item.menuName;
          let optionSelection = item.optionSelection;
          let optionList = [];
          if (optionSelection != null && optionSelection.length > 0) {
            let options = JSON.parse(optionSelection);
            for (let j = 0; j < options.length; j++) {
              if (options[j].field != undefined) {
                optionList.push(options[j].field);
              }
            }
          }


          if(optionList.length > 0) {
            title += ' (' + optionList.join(', ') + ')';
          }



          return title;
        },
        getOrderStateString: function(state, type, merchantName) {
          if(state == 0) {
            return 'Your order is placed. Wating for acceptance';
          } else if(state == 1) {
            return 'Change Request!. Please Confirm change';
          } else if(state == 2) {
            return 'Change Accepted';
          } else if(state == 3) {
            return 'Your order is accepted.'
          } else if(state == 4) {
            return 'Your order is in kitchen';
          } else if(state == 5) {
            if(type == 1) {
              return 'Your order is ready for collection';
            } else if(type ==2) {
              return 'Your order is on the way to you';
            }
          } else if(state == 6) {
            return 'Done';
          } else if(state == 7) {
            return 'Cancelled';
          }
          return 'Unknown(' + state + ')';
        },








        onMqttFailure: function (message) {
          //console.log("MQTT failed " + message);
          //console.log(message);
        },
        onMessageArrived: function (msg) {
          //console.log("message arrived");
          let msgStr = msg.payloadString;
          if (msgStr.startsWith("test")) {
            return;
          }
          let self = this;
          // console.log("")
          let item = JSON.parse(msgStr);

          let viewId = 0;
          if(item.changeRequest != undefined) {
            if(item.state != undefined && item.state == 1) {
              this.showPopup("Order Change", )
            }
            viewId = item.changeRequest;
            if(localStorage.getItem("tel") != null && localStorage.getItem("tel").length == 11) {
              let self = this;
              getMyOrder(localStorage.getItem("tel"), 0)
                .then(function(data) {
                  // console.log("my order list ");
                  // console.log(data);
                  if(data.success == true) {
                    self.$data.orderHistory = data.item;
                    // self.$data.showHistory = true;
                    setTimeout(function(){
                      let elem = document.getElementById("history-container");
                      if(elem != null) {
                        let target = document.getElementById("history-item-" + viewId);
                        elem.scrollTop = target.offsetTop;
                      }

                    }, 100);
                    self.getUserPoint();
                  }
                })
                .catch(function(err) {
                  // console.log(err);
                  // if(err.response != undefined) {
                  //   console.log(err.response);
                  // }
                })
              this.subscribe(localStorage.getItem("tel"));
            } else {
              // console.log("getHistory no tel");
            }
          }

          // if(msg.destinationName === 'yami/menus') {
          //   let item = JSON.parse(msgStr);
          //   for (let i = 0; i < self.$data.categories.length; i++) {
          //     for (let j = 0; j < self.$data.categories[i].products.length; j++) {
          //       if(item.id == self.$data.categories[i].products[j].id) {
          //         self.$data.categories[i].products[j].soldOut = item.soldOut;
          //       }
          //     }
          //   }
          // } else {
          //
          //   let item = JSON.parse(msgStr);
          //   if (item != undefined) {
          //     this.getPendingOrder(item.id, false);
          //   }
          // }
        },
        subscribe: function(channel) {
          if(this.$data.mqtt == null || this.$data.mqtt.isConnected() == false) {
            //console.log("MQTT is not connected");
            return;
          }
          for(let i = 0 ; i < this.$data.topics.length ; i++) {
            if(this.$data.topics[i] === channel) {
              //console.log("Already " + channel);
              return;
            }
          }
          //console.log("Subscribe now " + channel);
          this.$data.mqtt.subscribe("posPublic/" + channel);
          this.$data.topics.push(channel);
          //this.sendMessage("Hello I am customer");
        },
        onConnectionLost: function(resObj) {
          // console.log("connection lost");
          // this.$data.mqttConnected = false;
          this.$data.mqtt = null;
          // console.log("Lost connection to " + resObj.uri + "\nError code: " + resObj.errorCode + "\nError text: " + resObj.errorMessage);
          if(this.$data.mqttDisconnect == false) {
            this.connect();
          }
        },
        disconnect: function() {
          this.$data.mqttDisconnect = true;
          if(this.$data.mqtt != null && this.$data.mqtt.isConnected()) {
            this.$data.mqtt.disconnect();
          }
        },
        onConnect: function () {
          // console.log("Connected ");

          if(this.$data.mqtt == null || this.$data.mqtt.isConnected() == false) {
            // console.log("onConnect but " + this.$data.mqtt);
            return;
          }
          if(localStorage.getItem("tel") != null && localStorage.getItem("tel").length == 11) {
            this.subscribe(localStorage.getItem("tel"));
          }
        },
        connect: function () {
          this.$data.topics = [];
          this.$data.mqtt = new Paho.Client("mqtt.boriumstudio.com", Number(9001), "clientjsasdasd" + new Date().getTime());
          this.$data.mqtt.onConnectionLost = this.onConnectionLost;
          let options = {
            timeout: 3,
            useSSL: true,
            userName: "borium",
            password: "borium1234",
            onSuccess: this.onConnect,
            onFailure: this.onMqttFailure,
            reconnect : false,
          };
          this.$data.mqtt.onMessageArrived = this.onMessageArrived;
          //console.log("### Connect to MQTT ");
          this.$data.mqtt.connect(options); //connect
        }
      }
    }
</script>

<style scoped>
  .full-page {
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    z-index: 1028;
  }
</style>



// WEBPACK FOOTER //
// src/components/History.vue